/**
 * EstimateTrackButton
 * 
 * @Author: Focci
 * @Date: 2023-08-18 17:43:08
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-18 17:43:08
 */

'use client'

import PropTypes from 'prop-types'
import clsx from 'clsx'
import SVGUnclaimed from '@img/unclaimed.svg'
import SVGClaimed from '@img/claimed.svg'
import useLogin from '@hook/useLogin'
import useTrackStatus from '@hook/useTrackStatus'
import { PropertyTrackDialog } from '@comp/page/property/estimate/track'
import { ButtonBase } from '@comp/material'
import { useTranslations } from 'next-intl'
import { useCallback, useState } from 'react'

/**
* 认领房源按钮
*/
export function TrackButton({
  propertyId,
  size,
  ...buttonProps
}) {
  const tt = useTranslations('track')
  const { ready, isTracked } = useTrackStatus(propertyId)
  const isLarge = size === 'large'

  return (
    <ButtonBase 
      className="rounded-full"
      disabled={!ready}
      {...buttonProps}
    >
      <div 
        className={clsx([
          'rounded-full px-3 py-1 flex items-center',
          isLarge && 'h-6 md:h-7',
          isTracked ? 'bg-primary text-white' : 'bg-cf2'
        ])}
      >
        {
          isTracked 
            ? <SVGClaimed width=".7rem" /> 
            : <SVGUnclaimed width=".7rem" />
        }
        <span className="ml-1 whitespace-nowrap">
          {isTracked ? tt('claimed') : tt('claim')}  
        </span>
      </div>
    </ButtonBase>
  )
}

export default function EstimateTrackButton({
  hideViewButton,
  propertyId,
  Trigger = TrackButton,
  size
}) {
  const [open, setOpen] = useState(false)
  const { isLogin, openSigninDialog } = useLogin()

  const handleClick = useCallback(() => (
    isLogin ? setOpen(true) : openSigninDialog()
  ), [isLogin, openSigninDialog])

  return (
    <>
      <Trigger
        propertyId={propertyId}
        size={size}
        onClick={handleClick}
      />
      <PropertyTrackDialog 
        open={open}
        onClose={() => setOpen(false)}
        hideViewButton={hideViewButton}
        propertyId={propertyId}
      />
    </>
  )
}

EstimateTrackButton.propTypes = {
  size: PropTypes.string,
  propertyId: PropTypes.number,
}
